import { toStringQuery } from '@doltech/utils/lib/object';
import { getSnapshot } from 'mobx-state-tree';
import Router from 'next/router';
import * as React from 'react';

export const usePagination = (filter, shouldUpdateUrl = false) => {
  const handlePaging = React.useCallback(
    (pageNumber) => {
      filter.updatePage(pageNumber);
      if (shouldUpdateUrl) {
        Router.push({
          pathname: Router.pathname,
          query: toStringQuery(getSnapshot(filter)),
        });
      }
    },
    [filter, shouldUpdateUrl]
  );
  const handleSize = React.useCallback(
    (size) => {
      filter.updateSize(size);
      filter.updatePage(1);
      if (shouldUpdateUrl) {
        Router.push({
          pathname: Router.pathname,
          query: toStringQuery(getSnapshot(filter)),
        });
      }
    },
    [filter, shouldUpdateUrl]
  );

  const handleSortChange = React.useCallback(
    (sorter) => {
      filter.updateOrder(sorter.order);
      if (shouldUpdateUrl) {
        Router.push({
          pathname: Router.pathname,
          query: toStringQuery(getSnapshot(filter)),
        });
      }
    },
    [filter, shouldUpdateUrl]
  );

  return {
    handlePaging,
    handleSize,
    handleSortChange,
  };
};
